import { createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import { useMsal } from "@azure/msal-react";


export const sesionSlice = createSlice({
    name: 'sesion', //importante, ya que se realizara llamdo mas tarde por nombre
    initialState: {
        estudiante: { sesion: [], inicioCierre: [] }
    },
    reducers: {
        setSesion: (state, action) => {  //crear set
            state.estudiante = action.payload
        }
    }
})


export const { setSesion } = sesionSlice.actions

export default sesionSlice.reducer


export const getSesion = (accounts) => async (dispatch) => {



    //dispatch(setSesion(accounts))
    const mail = accounts[0].username

    try {

        return await axios
            .post(
                'https://ws.ugm.cl/api/v1_ufe/ufe_sesionCAE', { mail: mail },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': process.env.REACT_APP_TOKEN
                    }
                }
            )
            .then(response => {
                console.log('dispatch session', response.data)

                
                dispatch(setSesion(response.data))
                
            })

    } catch (error) {

        //console.log('dispatch error', error)

    }
 

}